import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useForm } from 'react-hook-form';
import NotificationAlert from 'componentes/generic/Notification.js';
const URI = ApiEndpoint + 'administration/';
const EditSubcustomer = ({ idSubcustomer, idCustomer, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const [subCustomer, setSubCustomer] = useState({
    descripcion: '',
    determinanate: ''
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const getSubcustomer = async () => {
    setSubCustomer(null);

    httpClient('GET', URI + 'subcustomer/' + idSubcustomer, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('descripcion', response.data.descripcion);
          setValue('determinanate', response.data.determinanate);
          setSubCustomer(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (idSubcustomer > 0) getSubcustomer();
  }, []);

  const onSubmit = data => {
    console.log(data);

    if (idSubcustomer > 0) {
      httpClient(
        'put',
        URI + 'subcustomer/' + idSubcustomer,
        {
          descripcion: data.descripcion,
          determinanate: data.determinanate,
          idcliente: idCustomer,
          idsubcliente: idSubcustomer
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'subcustomer',
        {
          descripcion: data.descripcion,
          determinanate: data.determinanate,
          idcliente: idCustomer
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Descripción</Form.Label>
                  <FormControl
                    {...register('descripcion', { required: true })}
                    defaultValue={subCustomer?.descripcion}
                    isInvalid={!!errors.descripcion}
                    type="text"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label> Determinante</Form.Label>
                  <FormControl
                    {...register('determinanate', {
                      pattern: {
                        value: /^\d{1,5}$/,
                        message: 'La Clave debe tener menos a cuatro caracteres'
                      }
                    })}
                    type="number"
                    defaultValue={subCustomer?.determinanate}
                    isInvalid={!!errors.determinante}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditSubcustomer.propTypes = {
  idSubcustomer: PropTypes.number.isRequired,
  idCustomer: PropTypes.string.isRequired,
  closeModal: PropTypes.func
};

export default EditSubcustomer;
